/* eslint-disable no-underscore-dangle */
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeSpeedLimitsFilter } from '../../../ac/onChangeMapFilters';
import { speedLimitsLegend } from '../../../constants/variables';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { SPEED_LIMITS_FILTER } from '../../../constants/filterStyles';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import LayerFeatureSearch from '../../LayerFeatureSearch/LayerFeatureSearch';
import styles from '../FilterSidebar.module.css';
import { searchSpeedLimitInTiles, highlightSpeedLimit, clearSpeedLimitHighlight } from '../../../utils/searchSpeedLimitInTiles';

const SpeedLimitsFilterComponent = ({
    mapFilters,
    onChangeSpeedLimitsFilter,
}) => {
    // ✅ НОВАЯ АРХИТЕКТУРА: использование стилей из filterStyles
    let items = speedLimitsLegend;
    if (SPEED_LIMITS_FILTER.style && SPEED_LIMITS_FILTER.styleKey) {
        items = getStyleFilterItems(SPEED_LIMITS_FILTER.style, SPEED_LIMITS_FILTER.styleKey);
    }

    return (
        <div>
            {/* Переиспользуемый компонент поиска */}
            <div style={{ padding: '10px' }}>
                <LayerFeatureSearch
                    searchFn={searchSpeedLimitInTiles}
                    highlightFn={highlightSpeedLimit}
                    clearFn={clearSpeedLimitHighlight}
                    placeholder={t`ID зоны скорости`}
                    notFoundMessage={t`Зона скорости не найдена в загруженных данных`}
                    successLabel={t`Найдена`}
                    searchLabel={t`Найти`}
                    resultFields={[ 'id', 'speed_limit' ]}
                />
            </div>
            <div className={styles.legHead}>{t`Зоны`}{':'}</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, color, label }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label && label.id ? label.id : value}>
                                {typeof label === 'string' ? label : (label && i18n._(label))}
                            </label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='poi'
                                        id={value}
                                        checked={mapFilters.speedLimitsStatuses.includes(value)}
                                        value={value}
                                        onChange={onChangeSpeedLimitsFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeSpeedLimitsFilter })(SpeedLimitsFilterComponent);
export const SpeedLimitsFilter = withDisplayedLayersCheck(ConnectedComponent, t`Зоны ограничения скорости`);
